import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk'

import { socketMiddleware } from './middleware/socket';
import rootReducer from './redux';

const isDevelopment = process.env.NODE_ENV !== 'production';

export default function configureStore(history, initialState) {
  // const offlineConfig = Object.assign({}, offlineConfigDefaults);
  const middlewares = [
    routerMiddleware(history),
    socketMiddleware,
    thunk,
  ];

  if (isDevelopment) {
    /* eslint-disable global-require, import/no-extraneous-dependencies */
    const { createLogger } = require('redux-logger');
    /* eslint-enable */
    middlewares.push(createLogger());
  }

  const store = createStore(rootReducer, initialState, applyMiddleware(...middlewares));
  
  if (isDevelopment && module.hot) {
    // This allows redux files to be hot reloaded
    module.hot.accept('./redux', () => {
      /* eslint-disable global-require */
      store.replaceReducer(require('./redux').default);
      /* eslint-enable */
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js